module.exports = __webpack_public_path__ + "static/media/screenshot6.a9d14b38.png";